import React from 'react';
import { Box, Drawer, Typography, List, ListItem, ListItemIcon, ListItemText, Avatar, ListItemButton } from '@mui/material';
import { getStoredUser } from '../services/authService';
import {
  drawerSx,
  headerBoxSx,
  logoImgSx,
  titleSx,
  listSx,
  listItemWrapperSx,
  listItemButtonSelectedSx,
  listItemButtonSx,
  leftLineSx,
  iconImgSx,
  listItemTextTypographySx,
  userBoxSx,
  userNameSx,
  userRoleSx,
} from './sidebar.styles';
import oprationNodeIcon from '../assets/oprationNode-Icon.png';
import guardIcon from '../assets/guard-Icon.png';
import centralCommandIcon from '../assets/central-command-icon.png';
import leStationIcon from '../assets/le-station-icon.png';
import auditLogIcon from '../assets/audit-log-icon.png';
import geographyIcon from '../assets/geography-icon.svg';
import wualtLogo from '../assets/wault-icon.svg';

const drawerWidth = 224;

const items = [
  { label: 'Operating Nodes', icon: oprationNodeIcon },
  { label: 'Guards', icon: guardIcon },
  { label: 'Central Command', icon: centralCommandIcon },
  { label: 'LE Stations', icon: leStationIcon },
  { label: 'Geography', icon: geographyIcon },
  { label: 'Audit Log', icon: auditLogIcon },
];

const Sidebar: React.FC<{ selected?: string; onNavigate?: (label: string) => void }> = ({ selected, onNavigate }) => {
  const user = getStoredUser();
  const displayName = user?.name ?? 'Admin';
  const role = user?.roles?.[0] ?? 'Administrator';
  const parts = displayName.trim().split(/\s+/);
  const initials = parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : parts[0].substring(0, 2).toUpperCase();

  return (
  <Drawer variant="permanent" anchor="left" sx={drawerSx}>
      <Box sx={headerBoxSx}>
        <Box component="img" src={wualtLogo} alt="Wualt" sx={logoImgSx} />
        <Typography sx={titleSx}>Wualt</Typography>
      </Box>

  <List sx={listSx}>
        {items.map((it) => {
          const isSelected = selected === it.label || (!selected && it.label === 'Operating Nodes');
          return (
            <ListItem key={it.label} disablePadding sx={listItemWrapperSx}>
                  <ListItemButton
                    selected={isSelected}
                    sx={isSelected ? listItemButtonSelectedSx : listItemButtonSx}
                    onClick={() => onNavigate && onNavigate(it.label)}
                  >
                {isSelected && <Box sx={leftLineSx} />}
                <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                  <Box component="img" src={it.icon} alt={`${it.label} icon`} sx={iconImgSx} />
                </ListItemIcon>
                <ListItemText primary={it.label} primaryTypographyProps={{ sx: listItemTextTypographySx }} />
                  </ListItemButton>
            </ListItem>
          );
        })}
      </List>

  <Box mt="auto" sx={userBoxSx}>
          <Avatar
            sx={{
              bgcolor: '#143133',
              width: '28px',
              height: '28px',
              borderRadius: '16777200px',
              opacity: 1,
              fontFamily: 'Inter, Arial, sans-serif',
              fontWeight: 700,
              fontSize: '9px',
              lineHeight: '13.5px',
              letterSpacing: '0.17px',
              color: '#FFFFFF',
            }}
          >
            {initials}
          </Avatar>
        <Box>
          <Typography sx={userNameSx}>{displayName}</Typography>
          <Typography sx={userRoleSx}>{role}</Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
